const TOKEN_KEY = 'token';

const isLogin = () => {
  return !!localStorage.getItem(TOKEN_KEY);
};

const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

const setToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

const hasRole = (roles: string[], myRoles: string[]) => {
  console.log(
    'hasRole',
    roles,
    myRoles,
    roles.some((role) => myRoles.includes(role))
  );
  return roles.some((role) => myRoles.includes(role));
};

export { isLogin, getToken, setToken, clearToken, hasRole };
